export const DEVK_PARTNERS = ['devk', 'devk-rechtskunden', 'devk-steuerungstarif', 'devk-diesel']
